<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-bed"></i> {{ _('Bookings') }}<template v-if="selectedProperty">: {{ selectedProperty.title }}</template></h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <Datatable :url="bookingUrl" :search="search" :type-filter="type" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import components from '~/lib/components'
import { ChannexBookingDetails, Datatable } from '#components'
import formatters from '~/lib/formatters'

export default {
  data () {
    let $this = this
    const _ = useNuxtApp().$translate
    return {
      bookings: [],
      selectedProperty: null,
      search: '',
      type: 'all',
      idCellClicked: false,
      orderIdCellClicked: false,
      tableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
        {
          title: _('Status'),
          field: 'status',
          widthGrow: 1,
          formatter: this.channexBookingStatusFormatter(),
          headerSort: false
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 5,
          responsive: 0,
          headerSort: false
        },
        {
          title: _('Arrival'),
          field: 'arrival_ts',
          widthGrow: 5,
          responsive: 0,
          formatter: this.dateFormatter(),
          headerSort: false
        },
        {
          title: _('Departure'),
          field: 'departure_ts',
          widthGrow: 5,
          responsive: 0,
          formatter: this.dateFormatter(),
          headerSort: false
        },
        {
          title: _('Rooms'),
          field: 'rooms',
          widthGrow: 1,
          responsive: 1,
          hozAlign: 'right',
          headerSort: false
        },
        {
          title: _('Total'),
          field: 'amount',
          widthGrow: 2,
          responsive: 1,
          formatter: this.numberFormatter(),
          hozAlign: 'right',
          headerSort: false
        },
        {
          title: _('Order'),
          field: 'order_id',
          widthGrow: 2,
          responsive: 0,
          hozAlign: 'right',
          headerSort: false,
          formatter: this.channexOrderIdFormatter(),
          cellClick (e, cell) {
            $this.orderIdCellClicked = true
          }
        },
        {
          title: 'ID',
          field: 'unique_id',
          widthGrow: 2,
          responsive: 0,
          headerSort: false,
          formatter: this.channexBookingIdFormatter(),
          cellClick (e, cell) {
            $this.idCellClicked = true
          }
        },
        ],
        initialSort: [{
          column: 'status',
          dir: 'asc'
        }],
        rowClick (e, row) {
          if ($this.orderIdCellClicked) {
            const data = row.getData()
            if (!data.order_id) {
              $this.refreshBooking(data.id, data.property_id)
              $this.orderIdCellClicked = false
              return
            }
          }
          if (!$this.idCellClicked) {
            $this.openOrder(row)
          } else {
            $this.openBooking(row)
          }
          $this.idCellClicked = false
          $this.orderIdCellClicked = false
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    bookingUrl () {
      return this.baseDomain + this.shopId + '/channexbookings' + (this.selectedProperty ? '/' + this.selectedProperty.id : '') + '.json?apikey=' + this.apiKey + this.versionStr
    },
    showFilters () {
      return false
    }
  },
  methods: {
    reload (url) {
      this.$refs.datatable.reload(url)
    },
    openOrder (row) {
      let orderId = row.getCell('order_id').getValue()
      if (orderId) {
        this.EventBus.$emit('showDetailsColumn', {
          shopId: this.shopId,
          component: 'OrderDetails',
          title: this._('Order') + ' ' + orderId,
          width: 6,
          data: {
            orderId: orderId,
            trail: this.componentTrail
          }
        })
      } else {
        this.openBooking(row)
      }
    },
    openBooking (row) {
      const data = row.getData()
      if (data.property_id && data.id) {
        this.showModal('channexbookingdetails', ChannexBookingDetails, {
          props: {
            channexProperty: data.property_id,
            channexBooking: data.id
          }
        })
      }
    },
    refreshBooking(bookingId, propertyId) {
      this.$socket.emit('message', {
        type: 'channexUpdate',
        data: {
          event: 'booking',
          id: bookingId,
          property_id: propertyId
        },
        shopId: this.shopId,
      })
    }
  },
  components: {
    Datatable
  },
  async created () {
    if (this.component && this.component.initData) {
      try {
        if (this.component.initData.property) {
          this.selectedProperty = this.component.initData.property
        } else {
          this.selectedProperty = null
        }
      } catch(e) {}
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['orderUpdate'] = () => {
        return this.reload(this.bookingUrl)
      }
      this.events = events
    }
    this.enableEventBus()
  },
  watch: {
    version () {
      this.reload(this.bookingUrl)
    }
  }

}

</script>